import React, { useEffect, useState } from 'react';
import axios from 'axios';

const PlatformAdminOrders = () => {
  const [loading, setLoading] = useState(true);
  const [shopList, setShopList] = useState([]);
  const [result, setResult] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [selectedShopId, setSelectedShopId] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');

  useEffect(() => {
    fetchData();
  }, [window.location.search]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const params = new URLSearchParams(window.location.search);
      const shopId = params.get('shop_id') || '';
      const status = params.get('status') || '';

      const res = await axios.get(
        `/api/platform_admin/orders?shop_id=${encodeURIComponent(shopId)}&status=${encodeURIComponent(status)}`,
        { withCredentials: true }
      );

      if (res.data && res.data.ok) {
        setShopList(Array.isArray(res.data.shop_list) ? res.data.shop_list : []);
        setResult(Array.isArray(res.data.result) ? res.data.result : []);
        setStatuses(Array.isArray(res.data.statuses) ? res.data.statuses : []);
        setSelectedShopId(res.data.selected_shop_id || '');
        setSelectedStatus(res.data.selected_status || '');
      } else if (res.data && res.data.redirect) {
        window.location.href = res.data.redirect;
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        const redirectUrl =
          err.response.data && err.response.data.redirect
            ? err.response.data.redirect
            : '/platform_admin/login';
        window.location.href = redirectUrl;
        return;
      }

      console.error('주문 목록 로드 실패:', err);
      setResult([]);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.get('/api/platform_admin/logout', {
        withCredentials: true,
      });

      if (res.data && res.data.ok && res.data.redirect) {
        window.location.href = res.data.redirect;
        return;
      }

      window.location.href = '/platform_admin/login';
    } catch (err) {
      console.error('로그아웃 실패:', err);
      window.location.href = '/platform_admin/login';
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    window.location.href = `/platform_admin/orders?shop_id=${encodeURIComponent(selectedShopId)}&status=${encodeURIComponent(selectedStatus)}`;
  };

  const formatNumber = (value) => {
    const num = Number(value || 0);
    return num.toLocaleString('ko-KR');
  };

  const formatDate = (value) => {
    if (!value) return '';
    return String(value).slice(0, 10);
  };

  return (
    <div className="bg-light min-vh-100">
      <nav className="navbar navbar-dark bg-dark px-4">
        <span className="navbar-brand">플랫폼 관리자</span>
        <div>
          <a href="/platform_admin/sellers" className="btn btn-sm btn-outline-light me-2">
            셀러관리
          </a>
          <a href="/platform_admin/shops" className="btn btn-sm btn-outline-light me-2">
            상점관리
          </a>
          <a href="/platform_admin/orders" className="btn btn-sm btn-outline-light active me-2">
            주문관리
          </a>
          <a href="/platform_admin/claims" className="btn btn-sm btn-outline-light me-2">
            클레임
          </a>
          <a href="/platform_admin/notices" className="btn btn-sm btn-outline-light active me-2">
            공지관리
          </a>
          <a href="/platform_admin/logout" onClick={handleLogout} className="btn btn-sm btn-danger">
            로그아웃
          </a>
        </div>
      </nav>

      <div className="container my-4">
        <h4 className="mb-3">📦 전체 주문</h4>

        <form className="row g-2 mb-3" onSubmit={handleSubmit}>
          <div className="col-md-4">
            <select
              name="shop_id"
              className="form-select"
              value={selectedShopId}
              onChange={(e) => setSelectedShopId(e.target.value)}
            >
              <option value="">전체 상점</option>
              {shopList.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <select
              name="status"
              className="form-select"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              <option value="">전체 상태</option>
              {statuses.map((st) => (
                <option key={st} value={st}>
                  {st}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-2">
            <button className="btn btn-primary w-100" type="submit">
              필터
            </button>
          </div>
        </form>

        <div className="card shadow-sm">
          <div className="card-body p-0">
            <table className="table table-hover mb-0 align-middle">
              <thead className="table-light">
                <tr>
                  <th>주문번호</th>
                  <th>상점</th>
                  <th>주문자</th>
                  <th className="text-end">결제금액</th>
                  <th className="text-center">상태</th>
                  <th className="text-center">주문일</th>
                  <th className="text-center">관리</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="7" className="text-center py-4">
                      불러오는 중...
                    </td>
                  </tr>
                ) : result.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center py-4">
                      주문 내역이 없습니다.
                    </td>
                  </tr>
                ) : (
                  result.map((row) => (
                    <tr key={row.id}>
                      <td>#{row.id}</td>
                      <td>{row.shop_name}</td>
                      <td>{row.buyer_name}</td>
                      <td className="text-end">{formatNumber(row.result_price)}원</td>
                      <td className="text-center">
                        <span className="badge bg-secondary">{row.status}</span>
                      </td>
                      <td className="text-center">{formatDate(row.order_date)}</td>
                      <td className="text-center">
                        <a
                          href={`/platform_admin/order_view?id=${row.id}`}
                          className="btn btn-sm btn-outline-primary"
                        >
                          상세
                        </a>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformAdminOrders;